/* ==========================================================================
   MEGAKRUNCH — Click-to-load facade for YouTube / Vimeo embeds (#55).

   The Liquid snippet `mk-video-facade` renders a button with a thumbnail.
   This script delegates clicks once at the document level and swaps the
   button for a real <iframe> on activation. That defers ~700KB of
   third-party player JS / CSS / fonts until the customer actually wants
   to watch the video.

   No-op gracefully if there are no facades on the current page. Safe to
   load globally with defer.

   The facade buttons expose three data attributes:
     - data-mk-video-embed: full iframe src (with autoplay=1 already baked
       in so the iframe starts playing as soon as it loads)
     - data-mk-video-allow: the `allow` attribute for the iframe
     - data-mk-video-title: human-readable title for `title=` on the iframe

   The iframe inherits the button's class list (minus mk-video-facade) so
   sections that style .mk-video-pair-ext__iframe etc. keep working.
   ========================================================================== */

(function () {
  function activate(button) {
    var embed = button.getAttribute('data-mk-video-embed');
    if (!embed) return;

    var iframe = document.createElement('iframe');
    iframe.src = embed;
    iframe.setAttribute('allow', button.getAttribute('data-mk-video-allow') || 'autoplay');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', button.getAttribute('data-mk-video-title') || 'Video');
    iframe.setAttribute('frameborder', '0');

    // Carry section-specific classes onto the iframe so existing CSS
    // (e.g. .mk-video-pair-ext__iframe) keeps working.
    button.classList.forEach(function (cls) {
      if (cls !== 'mk-video-facade') iframe.classList.add(cls);
    });

    button.parentNode.replaceChild(iframe, button);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-mk-video-facade]');
    if (!button) return;
    e.preventDefault();
    activate(button);
  });
})();
